import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "types/store";
import styles from "./style.module.css";
import { Button } from "aible";
import { toast } from "react-toastify";
import Select from "react-select";
import { isOptionType } from "utils/select";
import aibleIconSVG from "images/Aible_Badge-Full-Color.svg";
import { LineInput } from "components/Inputs/LineInput";
import ModelSelector from "components/ChatGPT/ModelSelector";
import * as chatAppReducer from "containers/ChatApp/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";
const CreateAZTestModal = ({ showModal, updateShowModal, id }) => {
    const dispatch = useDispatch();
    const [isLoading, updateIsLoading] = useState(false);
    const blueprints = useSelector((state) => blueprintReducer.getGlobal(state));
    const selectedBlueprint = useSelector((state) => blueprintReducer.getBlueprint(state, id));
    const newChatAppName = selectedBlueprint?.name + " (Intern)";
    const azTestApps = useSelector((state) => chatAppReducer.getActiveAZTests(state));
    const azTestOptions = [
        {
            value: undefined,
            label: "Create New Test"
        },
        ...azTestApps.map((app) => {
            return {
                value: app?.id,
                label: app?.name
            };
        })
    ];
    const newModel = useSelector((state) => chatAppReducer.getChatAppFineTunedModel(state, id));
    const [selModel, updateSelModel] = useState(newModel);
    const parentAZTest = useSelector((state) => chatAppReducer.getChatAppAZTest(state, id));
    const [selTest, updateSelTest] = useState(parentAZTest);
    const selectedTest = useSelector((state) => blueprintReducer.getBlueprint(state, selTest));
    const selectedTestCurrSettings = useSelector((state) => chatAppReducer.getCurrentAZTest(state, selTest));
    const selectedTestDistribution = {};
    let remaining = 100;
    const selectedTestApps = ["NEW_CHAT_APP", ...(selectedTestCurrSettings?.testApps || [id])];
    selectedTestApps.forEach((rId, i) => {
        let currVal = Math.round(100 / (selectedTestApps.length || 1));
        if (i === selectedTestApps.length - 1) {
            currVal = remaining;
        }
        remaining -= currVal;
        selectedTestDistribution[rId] = currVal || 0;
    });
    const selectedTestDefaultName = selectedTest?.name ?? selectedBlueprint?.name + " (Intern Test)";
    const [selTestName, updateSelTestName] = useState(selectedTestDefaultName);
    const [selDistribution, updateSelDistribution] = useState(selectedTestDistribution);
    const selectedAZTest = azTestOptions?.find((o) => o?.value === selTest);
    const remainingDistribution = Object.keys(selDistribution).reduce((acc, dKey) => {
        const currVal = selDistribution[dKey] ?? 0;
        return acc - currVal;
    }, 100);
    const [showTestSettings, updateShowTestSettings] = useState(!selTest);
    useEffect(() => {
        updateSelModel(newModel);
        updateSelTest(parentAZTest);
        updateShowTestSettings(!parentAZTest);
        updateSelTestName(selectedTestDefaultName);
        updateSelDistribution(selectedTestDistribution);
    }, [id]);
    useEffect(() => {
        updateShowTestSettings(!selTest);
        updateSelTestName(selectedTestDefaultName);
        updateSelDistribution(selectedTestDistribution);
    }, [selTest]);
    const retImgSrc = selectedBlueprint?.wizard?.base64StringLogo;
    const handleClose = () => {
        updateShowModal(false);
    };
    const handleCreate = async () => {
        updateIsLoading(true);
        try {
            const currOptions = {
                appId: id,
                appName: newChatAppName,
                modelId: selModel,
                selectedTest: selTest,
                newTestName: selTestName,
                newTestDistribution: selDistribution
            };
            await dispatch(chatAppReducer.createAZTestForIntern(currOptions));
            toast(`${selTestName} is ready to use!`, {
                type: toast.TYPE.SUCCESS,
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3500
            });
        }
        catch (e) {
            console.log(e);
        }
        updateIsLoading(false);
        handleClose();
    };
    return (React.createElement("div", null,
        React.createElement(Dialog, { open: showModal, onOpenChange: () => {
                handleClose();
            } },
            React.createElement(DialogContent, null,
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null,
                        React.createElement("div", { className: retImgSrc ? styles.createAZTestModalHeaderIcon : styles.createAZTestModalHeaderIconDefault },
                            React.createElement("img", { src: retImgSrc ? retImgSrc : aibleIconSVG, style: { width: "100%" } })),
                        React.createElement("div", null, `WELCOME TO ${selectedBlueprint?.name}`))),
                React.createElement("div", { className: styles.createAZTestModalBody },
                    React.createElement("div", { className: styles.createAZTestModalItem },
                        React.createElement("div", { className: styles.createAZTestModalItemTitle }, "New Aible Intern Available"),
                        React.createElement("div", { className: styles.createAZTestModalItemSubtitle }, "Would you like to start evaluating its improvements today?"),
                        React.createElement("div", { className: styles.createAZTestModalItemSelect },
                            React.createElement(ModelSelector, { hideIcons: true, modelId: selModel, updateModelId: updateSelModel }))),
                    React.createElement("div", { className: styles.createAZTestModalItem },
                        React.createElement("div", { className: styles.createAZTestModalItemTitle }, "Recommended A/Z Test"),
                        React.createElement("div", { className: styles.createAZTestModalItemSubtitle }, "The test will track how much better the model performs for the user chats"),
                        React.createElement("div", { className: styles.createAZTestModalItemSelect },
                            React.createElement(Select, { options: azTestOptions, value: selectedAZTest, onChange: (val) => {
                                    if (isOptionType(val)) {
                                        updateSelTest(val?.value);
                                    }
                                } }))),
                    React.createElement("a", { className: styles.createAZTestModalItemSubtitle, onClick: () => updateShowTestSettings(!showTestSettings) }, `${showTestSettings ? "Hide" : "Show"} A/Z test settings`),
                    showTestSettings && (React.createElement("div", { className: styles.createAZTestModalBody },
                        !selTest && (React.createElement("div", { className: styles.createAZTestModalItem },
                            React.createElement("div", { className: styles.createAZTestModalItemTitle }, "A/Z Test Name"),
                            React.createElement("div", { className: styles.createAZTestModalItemInput },
                                React.createElement(LineInput, { isBox: true, inputStyle: { width: "100%" }, placeholder: "Name your test", value: selTestName, onChange: (val) => updateSelTestName(val) })))),
                        React.createElement("div", { className: styles.createAZTestModalItem },
                            React.createElement("div", { className: styles.createAZTestModalItemTitle }, "Distribution"),
                            Object.keys(selDistribution).map((dKey) => {
                                let dName = blueprints?.[dKey]?.name;
                                if (dKey === "NEW_CHAT_APP") {
                                    dName = newChatAppName;
                                }
                                const currDist = selDistribution[dKey];
                                return (React.createElement("div", { className: styles.createAZTestModalItemSubItem, key: "dist_" + dKey },
                                    React.createElement("div", { className: styles.createAZTestModalItemSubtitle }, dName),
                                    React.createElement("div", { className: styles.createAZTestModalItemInput },
                                        React.createElement(LineInput, { isBox: true, inputStyle: { width: "40px" }, value: currDist, onChange: (val) => {
                                                const retDistribution = {
                                                    ...selDistribution,
                                                    [dKey]: Number(val) || 0
                                                };
                                                updateSelDistribution(retDistribution);
                                            } }))));
                            }),
                            remainingDistribution < 0 && (React.createElement("div", { className: styles.modalDistributionWarning }, `${Math.abs(remainingDistribution)}% over allocated`)),
                            remainingDistribution > 0 && (React.createElement("div", { className: styles.modalDistributionWarning, style: { color: "#7c7c7c" } }, `${remainingDistribution}% unallocated`)))))),
                React.createElement(DialogFooter, null,
                    React.createElement(Button, { onClick: () => {
                            handleClose();
                        } }, "Close"),
                    React.createElement(Button, { onClick: () => {
                            handleCreate();
                        }, isLoading: isLoading }, "Start Testing New Model"))))));
};
export default CreateAZTestModal;
